import React from "react";
import { CheckIcon, MinusIcon } from "lucide-react";
import { comparisonRows } from "../../data/sections";
import { SectionHeading } from "../ui/SectionHeading";
export function Comparison() {
  return <section id="comparacion" aria-labelledby="comparacion-title" className="scroll-mt-20 bg-pizarra-deep py-20 text-marfil md:py-28" data-id="element-12" data-mp="1dvgie4l3nbn6">
      <div className="mx-auto max-w-5xl px-4 md:px-6" data-id="element-13" data-mp="1iu1hu1sj1rak">
        <SectionHeading id="comparacion-title" tone="dark" eyebrow="La diferencia" title="Recursos dispersos o estudio organizado" intro="El contenido puede ser parecido. Lo que cambia es saber dónde estás y qué hacer después." data-id="element-14" data-mp="m52covn8p5ml" />
        <div className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-15" data-mp="1041upkg8ym9s">
          <div className="rounded-3xl border border-marfil/15 p-6 md:p-8" data-id="element-16" data-mp="105mpnb6h4786">
            <h3 className="font-serif text-2xl text-crema" data-id="element-17" data-mp="26jm3wtjz94o2">Recursos dispersos</h3>
            <ul className="mt-6 space-y-5" data-id="element-18" data-mp="2bip6868kowsc">
              {comparisonRows.map(r => <li key={r.scattered} className="flex gap-3 text-crema/90" data-id="element-19" data-mp="1kz2yopdnq3kc">
                  <MinusIcon className="mt-1 h-4 w-4 shrink-0 text-sakura" aria-hidden="true" data-id="element-20" data-mp="1gwzmtzn2swyj" />
                  {r.scattered}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl bg-marfil p-6 text-pizarra-deep md:p-8" data-id="element-21" data-mp="16ysbbwbk373x">
            <h3 className="font-serif text-2xl" data-id="element-22" data-mp="170wa5zullfxc">Con el Megapack de Japonés</h3>
            <ul className="mt-6 space-y-5" data-id="element-23" data-mp="1219wxqerrzoj">
              {comparisonRows.map(r => <li key={r.organized} className="flex gap-3 font-medium" data-id="element-24" data-mp="x873di9zsq8c">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-salvia-deep" strokeWidth={3} aria-hidden="true" data-id="element-25" data-mp="t6lue80kww3f" />
                  {r.organized}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}